import mitt from 'mitt';
export const FLAG_PREFIX = 'flagKey.';
export const ALL_FLAGS = 'allFlags';
export default class Subscriptions {
  constructor() {
    this.emitter = mitt();
  }
  on(flagKey, defaultValue, callback, getFlagValue, options) {
    const wrapCallback = () => callback(getFlagValue(flagKey, defaultValue, options));
    this.emitter.on(FLAG_PREFIX + flagKey, wrapCallback);
    return () => this.emitter.off(FLAG_PREFIX + flagKey, wrapCallback);
  }
  onAnyFlagUpdated(callback) {
    this.emitter.on(ALL_FLAGS, callback);
    return () => this.emitter.off(ALL_FLAGS, callback);
  }
  anyFlagUpdated() {
    this.emitter.emit(ALL_FLAGS);
  }
  flagValueUpdated(flagKey) {
    this.emitter.emit(FLAG_PREFIX + flagKey);
  }
  stop() {
    // There is no way to clear the emitter so instead we're creating a new one
    this.emitter = mitt();
  }
}